// @flow

import {unsafelyParseMarkdown, Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ReportingCategoryList: MarkdocTagRegistration = {
  tag: 'reporting-category-list',
  component: 'ReportingCategoryList',
  attributes: {
    reportingCategoryGroups: {
      type: Array,
      description: 'Array of reporting category groups objects',
    },
    reportingCategoryMap: {
      type: Object,
      description:
        'Object mapping from reporting category group name to an array of reporting category objects',
    },
  },
  render(node, config) {
    const children = node.renderChildren(config);
    const attributes = node.renderAttributes(this.attributes, config);
    const {reportingCategoryGroups, reportingCategoryMap} = attributes;

    if (reportingCategoryGroups) {
      reportingCategoryGroups.forEach((group) => {
        group.description = unsafelyParseMarkdown(group.description, config);
      });

      attributes.reportingCategoryGroups = reportingCategoryGroups;
    }

    if (reportingCategoryMap) {
      Object.keys(reportingCategoryMap).forEach((groupID) => {
        const reportsInGroup = reportingCategoryMap[groupID];
        if (!reportsInGroup) {
          // Make sure that the report group is declared in the reports context
          throw new Error(`Report group not found: ${groupID}`);
        }

        reportsInGroup.forEach((report) => {
          report.description = unsafelyParseMarkdown(
            report.description,
            config,
          );
        });
      });

      attributes.reportingCategoryMap = reportingCategoryMap;
    }

    return new Tag(this.tag, attributes, children);
  },
};
